"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_separator_1 = __importDefault(require("@doordash/component-separator"));
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
var types_1 = require("../../types");
var Search_1 = __importDefault(require("../Search"));
var styles_1 = require("./styles");
var utils_1 = require("./utils");
var EntityRelationship = function (_a) {
    var onAdd = _a.onAdd, onRemove = _a.onRemove, onModifyLinkAttributes = _a.onModifyLinkAttributes, relationship = _a.relationship, linkAttributes = _a.linkAttributes, relationshipKeysToShow = _a.relationshipKeysToShow;
    return (React.createElement(styles_1.EntityRelationshipWrapper, null,
        React.createElement(styles_1.RelationshipAttributeWrapper, null,
            React.createElement("div", null, relationshipKeysToShow.map(function (key) { return (React.createElement(design_language_1.Text, { size: design_language_1.Text.Sizes.S14, key: key },
                lodash_1.startCase(key),
                ": ",
                relationship[key])); })),
            onRemove && (React.createElement(design_language_1.Icon, { onClick: onRemove, type: design_language_1.Icon.Types.CloseCircleLine })),
            onAdd && React.createElement(design_language_1.Icon, { onClick: onAdd, type: design_language_1.Icon.Types.AddCircleLine })),
        linkAttributes && (React.createElement(React.Fragment, null,
            React.createElement(design_language_1.Inset, { size: design_language_1.Inset.Sizes.XxSmall },
                React.createElement(component_separator_1["default"], { type: component_separator_1["default"].Types.FullBorder })),
            Object.keys(linkAttributes).map(function (k, index) {
                var _a = linkAttributes["" + k], type = _a.type, props = _a.props;
                var Field = types_1.FieldTypes[type];
                return (React.createElement(Field, __assign({}, props, { key: index, value: relationship[k], label: lodash_1.startCase(k) + ":", onChange: function (newValue) {
                        var _a;
                        return onModifyLinkAttributes(__assign(__assign(__assign({}, relationship), relationship.linkAttributes), (_a = {}, _a["" + k] = newValue, _a)));
                    } })));
            })))));
};
var EntityRelationshipInput = function (_a) {
    var label = _a.label, onChange = _a.onChange, value = _a.value, relationshipKeysToShow = _a.relationshipKeysToShow, linkAttributes = _a.linkAttributes, onSearch = _a.onSearch, _b = _a.minimumResultCharLength, minimumResultCharLength = _b === void 0 ? 2 : _b;
    return (React.createElement(styles_1.EntityRelationshipInputWrapper, null,
        React.createElement(styles_1.ColumnWrapper, null,
            React.createElement(design_language_1.Text, { size: design_language_1.Text.Sizes.S14 }, label),
            value.map(function (relationship, index) { return (React.createElement(EntityRelationship, { key: index, onRemove: function () {
                    utils_1.removeRelationship(index, value, onChange);
                }, onModifyLinkAttributes: function (modifiedRelationship) {
                    utils_1.modifyRelationship(index, modifiedRelationship, value, onChange);
                }, relationship: relationship, linkAttributes: linkAttributes, relationshipKeysToShow: relationshipKeysToShow })); })),
        React.createElement(styles_1.ColumnWrapper, null,
            React.createElement(design_language_1.Text, { size: design_language_1.Text.Sizes.S14 },
                "Add ",
                label),
            React.createElement(design_language_1.Stack, { size: design_language_1.Stack.Sizes.XSmall }),
            React.createElement(Search_1["default"], { isLabelHidden: true, label: label, minimumResultCharLength: minimumResultCharLength, onSearch: onSearch, onResults: function (results) {
                    return results.map(function (relationship, index) { return (React.createElement(EntityRelationship, { key: index, onAdd: function () { return utils_1.addRelationship(relationship, value, onChange); }, relationship: relationship, relationshipKeysToShow: relationshipKeysToShow })); });
                } }))));
};
exports["default"] = EntityRelationshipInput;
